// extracted by mini-css-extract-plugin
module.exports = {"section":"k_2S3T6","inner":"k_10tAc","wrap":"k_21Uie","aboutList":"k_3K7Lu","picture":"k_1rjoD"};